<template>
  <div>
    <v-card class="pa-8">
      <v-form v-model="Validity" ref="SubmissionForm">
        <v-row no-gutters justify="center">
          <v-col cols="12">
            <v-row class="mb-4" justify="start" no-gutters>
              <h4 class="font-weight-black ThemeFont">Contact Details</h4>
            </v-row>

            <h6 class="ml-1 mr-1 text-start">Name</h6>
            <v-text-field
                :rules="[v => !!v || 'Name is required']"
                v-model="name"
                prepend-inner-icon="mdi-account-outline"
                outlined placeholder="Your Name"></v-text-field>
            <h6 class="ml-1 mr-1 text-start">NIC</h6>
            <v-text-field
                v-model="nic"
                :rules="[v => !!v || 'NIC is required']"
                prepend-inner-icon="mdi-account-outline"
                outlined placeholder="Your NIC"></v-text-field>
            <h6 class="ml-1 mr-1 text-start">Email</h6>
            <v-text-field
                v-model="email"
                :rules="[v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Invalid Email address']"
                prepend-inner-icon="mdi-email-outline"
                outlined placeholder="Your Email"></v-text-field>
            <h6 class="ml-1 mr-1 text-start">Telephone No.</h6>
            <v-text-field
                v-model="telephone"
                :rules="[v => !!v || 'Telephone is required']"
                prepend-inner-icon="mdi-phone-outline"
                outlined placeholder="Your Telephone No"></v-text-field>

            <h5 class="ml-1 mr-1 text-start">Additional Telephone No.</h5>
            <v-text-field
                v-model="ad_telephone"
                prepend-inner-icon="mdi-phone-outline"
                outlined placeholder="Enter Your Additional Phone Number"></v-text-field>

            <h6 class="ml-1 mr-1 text-start">Address</h6>
            <v-text-field
                v-model="address"
                :rules="[v => !!v || 'Address is required']"
                prepend-inner-icon="mdi-home-outline"
                outlined placeholder="Your Address"></v-text-field>
          </v-col>
        </v-row>
      </v-form>

    </v-card>

    <v-card dark elevation="0" class="mt-n1 rounded-t-0" color="primary">
      <v-progress-linear color="white" v-if="loading" indeterminate></v-progress-linear>
      <v-container>
        <v-row align="center" justify="space-between" no-gutters>
                      <span class="text--white text-h5">Total<span class="font-weight-black ml-4">
                        {{ MoneyFormat(total) }}
                      </span></span>


          <v-col cols="auto">
            <v-btn @click="Back" outlined class="mr-2" width="128" height="56"
                   color="white" light>Back
            </v-btn>
            <v-btn class="font-weight-bold" @click="Submit" width="128" height="56" color="#D6AF44" light>
              Book Now
            </v-btn>
          </v-col>

        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SubmitBooking",
  props: {
    total: Number,
    package: Number,
    park: Number,
    pax: Number,
    cindate: String,
    coutdate: String,
    addons: Array,
    parkobj: Object,
    packagetitle: String,
    parktitle: String,
  },
  data: () => ({
    loading: false,
    Validity: false,
    name: null,
    nic: null,
    email: null,
    address: null,
    telephone: null,
    ad_telephone: null
  }),
  methods: {
    Back() {
      this.$emit('Back');
    },
    MoneyFormat(value){
      return Intl.NumberFormat('en-US', { style: 'currency', currency: 'LKR' }).format(value);
    },
    Submit() {

      this.$refs.SubmissionForm.validate();

      if (this.Validity) {
        this.loading = true;
        let ads = [];
        this.addons.forEach(function (item) {
          ads.push({
            addon_id: item.id,
          });
        });
        axios.post('https://admin.wca.innocube.lk/api/create-booking', {
          "package_id": this.package,
          "park_id": this.park,
          "pax": this.pax,
          "check_in_date": this.cindate,
          "check_out_date": this.coutdate,
          "addons": ads,
          "customer_name": this.name,
          "customer_email": this.email,
          "customer_address": this.address,
          "customer_phone_number": this.telephone,
          "package_title": this.packagetitle,
          "park_title": this.parktitle,
          "package_price": this.total,
          "customer_additional_no": this.ad_telephone,
          "customer_nic": this.nic,
        }).then(value => {
          console.log(value);
          this.loading = false;
          this.$emit('SaveInvoice', value.data.booking_details);
          this.$emit('Forward');
        }).catch(error => {
          console.log(error);
          this.loading = false;
        });
      }
    }
  },
}
</script>

<style scoped>

</style>
